<template>
  <el-select
      class="tags-select"
      style="width: 100%"
      :disabled="disableOrNot"
      v-model="studentLabel"
      multiple
      placeholder="请选择"
      ref="selectRefs"
      :placeholder="placeholder"
      @change="handleSelectionChange"
      fixed>
    <el-input
        style="width: 75%"
        placeholder="输入关键字搜索"
        v-model="filterText"
        @click.stop.native
        class="sel-input"
        v-if="studentData.length !== 0">
    </el-input>
    <el-button @click="clearTreeSelect" type="primary" style="width: 20%">清除</el-button>
    <el-option v-model="studentLabel" class="sel-option" style="width: 100%">
      <el-tree
          style="width: 100%"
          :data="studentData"
          :props="studentDataProps"
          :default-checked-keys="existStudentIds"
          :default-expanded-keys="existStudentIds"
          :node-key="'id'"
          show-checkbox
          :render-after-expand="false"
          accordion
          @check-change="handleCheckChange"
          :filter-node-method="filterNode"
          ref="studentDataTree">
      </el-tree>
    </el-option>
  </el-select>
</template>

<script>

export default {
  name: 'StudentTree',
  props: {
    disableOrNot: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: ''
    },
    studentData: {
      type: Array,
      default: () => []
    },
    studentDataProps: {
      type: Object,
      default: () => {
        return {
          id: 'id',
          label: 'label',
          children: 'children'
        }
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    existStudentIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      leafNodes: [],
      filterText: '',
      studentLabel: [],
      localStudentIds: [],
    }
  },
  watch: {
    filterText(val) {
      this.filterTree(val);
    },
    localStudentIds: {
      handler(newval, oldval) {
        if (newval) {
          this.$emit('update:userIds', this.localStudentIds);
        }
      },
    },
    existStudentIds: {
      handler(newval, oldval) {
        if (newval && newval.length === 0){
          this.clearTreeSelect();
        }
      }
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    //节点选中状态发生变化时的回调
    handleCheckChange() {
      //获取所有选中的节点 start
      let res = this.$refs.studentDataTree.getCheckedNodes();
      let studentId = [];
      this.studentLabel = [];
      res.forEach((item) => {
        if (item.isLeaf) {
          studentId.push(item.id);
          this.studentLabel.push(item.label);
        }
      });
      this.localStudentIds = studentId;
    },

    filterTree(keywords) {
      this.$refs.studentDataTree.filter(keywords);
    },

    handleSelectionChange(value) {
      this.studentLabel = value;
    },

    //获取叶子节点
    getLeafNodes(tree) {
      if (!tree) {
        return [];
      }
      const leafNodes = [];
      const queue = [];

      // 初始根节点入队
      queue.push(...tree);

      while (queue.length) {
        const node = queue.shift(); // 出队处理当前节点

        // 判断当前节点是否为叶子节点，并且 isLeaf 为 true
        if (node.isLeaf) {
          leafNodes.push(node); // 添加当前叶子节点到结果列表
        }

        if (node.children) {
          // 将当前节点的子节点入队
          queue.push(...node.children);
        }
      }
      return leafNodes;
    },

    //清除
    clearTreeSelect() {
      this.$refs.studentDataTree.setCheckedKeys([]);
    }

  },

};
</script>

<style>
.sel-option {
  width: 300px;
  height: auto;
  max-height: 200px;
  overflow: auto;
  cursor: pointer;
  font-weight: normal !important;
  padding: 0 5px;
}

.sel-input {
  width: 300px;
  margin: 5px;
}
.sel-option .el-tag__close {
  display: none;
}
.el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

.tags-select .el-tag__close.el-icon-close {
  display: none;
}
</style>
